

const ThankComp = () => {
    return ( 
        <>
<div class="container border p-5 my-5 b_cont">
    <div class="wrapper-2 m-auto border text-center b_cont py-4">
      <h1 className="h1" style={{"color":"#E52020"}}>Thank you !</h1>
      <p>Thanks for signing up for your free website.</p>
      <p>You'll be contacted as soon as possible.</p>
      <a href="/" ><button type="submit" className="btn text-light t_btn" style={{ backgroundColor: '#E52020',width:"40%" }}>Go Home</button></a>
    </div>
      <div class="mb-0 border text-center bg-dark">
      <p className="text-light">Send another message? 
       <a href="/" className="text-danger">Click here</a>
      </p>
</div>
</div>
        </>
     );
}
 
export default ThankComp;